import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { router } from "router";

import { StartApplicationSection } from "@krea/customer/src/components/preliminary-bid-form/startApplicationSection";
import { useMobile } from "@krea/customer-features/hooks";
import { FORM_STEP } from "@krea/customer-features/shared-components/application-form";
import EligibilityCheckResult from "@krea/customer-features/shared-components/eligibility-check-result";
import AppFormPromotion from "@krea/customer-features/shared-components/loan-application-form/AppFormPromotion";
import LoanApplicationFormLayout from "@krea/customer-features/shared-components/loan-application-form-layout";
import { useLoanApplicationFormStore } from "@krea/customer-features/store/loan-application-form/hooks";
import twMerge from "@krea/customer-features/utils/tailwind-utils";

export const EligibilityCheckResultPage = () => {
  const { t } = useTranslation();
  const isMobile = useMobile();

  const eligibilityCheck = useLoanApplicationFormStore(
    (state) => state.eligibilityCheck,
  );

  const handleSubmit = () => {
    const { setCurrentStep } = useLoanApplicationFormStore.getState();
    // Since we have all the data needed in the BASIC_DETAILS step
    // We could transition directly into the PRIMARY_PURPOSE step.
    setCurrentStep(FORM_STEP.PRIMARY_PURPOSE);

    router.navigate("/application");
  };

  const probabilityOptions = {
    low: t("preliminaryBidForm.probabilityOptions.low"),
    medium: t("preliminaryBidForm.probabilityOptions.medium"),
    high: t("preliminaryBidForm.probabilityOptions.high"),
  };

  const probabilityKey =
    eligibilityCheck &&
    (eligibilityCheck.probabilityLoanApproved as keyof typeof probabilityOptions);

  const probability = probabilityKey
    ? probabilityOptions[probabilityKey]
    : null;

  const resultHeading =
    probability === probabilityOptions.high &&
    !eligibilityCheck?.useEdgeCaseLogic
      ? t("eligibilityCheckForm.goodNews")
      : t("eligibilityCheckForm.yourChancesToQualify");

  const innerForm = (
    <div className="tw-mt-4 xl:tw-mt-8">
      <EligibilityCheckResult isOnResultPage />
      <StartApplicationSection handleSubmit={handleSubmit} />
    </div>
  );

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      {!isEmpty(eligibilityCheck) ? (
        <div className="tw-flex">
          <div
            className={twMerge({
              "tw-w-full": isMobile,
              "tw-w-[65%]": !isMobile,
            })}
          >
            <div
              className={twMerge("tw-mx-auto", {
                "tw-w-[80%]": !isMobile,
              })}
            >
              <LoanApplicationFormLayout
                innerForm={innerForm}
                hideAdvisorCTABanner
                hasTestimonials
                borderlessInnerForm
                goToNextStep={handleSubmit}
                customButtonText={t("applicationForm.common.continue")}
                heading={resultHeading}
                goToPreviousStep={() => {}}
                hideNavigation={!isMobile}
              />
            </div>
          </div>

          {!isMobile && (
            <div className="tw-mx-2 tw-max-h-[950px] tw-min-h-[855px] tw-min-w-[400px] tw-max-w-[500px]">
              <AppFormPromotion />
            </div>
          )}
        </div>
      ) : (
        <Navigate to="/eligibility-check" />
      )}
    </form>
  );
};
